import { render, staticRenderFns } from "./detailSkillsTable.vue?vue&type=template&id=61d9a508&scoped=true"
import script from "./detailSkillsTable.vue?vue&type=script&lang=js"
export * from "./detailSkillsTable.vue?vue&type=script&lang=js"
import style0 from "./detailSkillsTable.vue?vue&type=style&index=0&id=61d9a508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d9a508",
  null
  
)

export default component.exports